// Project image mappings based on folder structure
export const projectImageMap = {
  'SindhuligadhiWarMuseum': [
    '20200320_123429.jpg',
    '20200330_160311.jpg',
    '20200516_090200.jpg',
    '20200516_090210.jpg',
    '20200707_134152.jpg',
    '20200914_140916.jpg',
    '20200914_140939.jpg',
    '20200925_173940.jpg',
    '20200925_173950.jpg',
    '2077-06-15.jpg'
  ],
  'GaighatDiktelRoad': [
    '2014-05-29 15.02.34.jpg',
    '2015-03-06 09.45.06.jpg',
    '2015-03-06 09.45.12.jpg',
    '2015-03-06 09.45.28.jpg',
    '2015-03-07 14.54.29.jpg',
    '2015-03-07 14.54.33.jpg',
    '2015-03-07 14.55.57.jpg',
    '2015-03-07 14.58.55.jpg',
    '2015-03-07 14.59.00.jpg',
    '2015-03-07 14.59.04.jpg',
    '2015-03-07 15.15.33.jpg',
    '2015-03-07 15.15.39.jpg',
    '2015-03-07 15.15.45.jpg',
    '2015-03-07 15.15.50.jpg',
    'gaighat1.png.png',
    'gaighat2.png.png',
    'gaighat3.png.png',
    'gaighat4.png.png',
    'gaighat5.png.png',
    'gaighat6.png.png',
    'gaighat7.png.png'
  ],
  'SitkhaHighwayProject': [
    'no 030.jpg',
    'no 031.jpg',
    'no 032.jpg',
    'no 033.jpg',
    'no 034.jpg',
    'no 035.jpg',
    'no 036.jpg',
    'no 037.jpg',
    'no 042.jpg',
    'no 043.jpg',
    'no 044.jpg',
    'no 045.jpg',
    'no 445.jpg',
    'Untitled.png',
    'Untitled2.png'
  ],
  'JajarkotHighway': [
    'Jajarkot1.png',
    'Jajarkot2.png',
    'Jajarkot3.png'
  ],
  'GwaltarSungureTrack': [
    'no 034.jpg',
    'no 035.jpg',
    'no 036.jpg',
    'no 037.jpg',
    'no 042.jpg',
    'no 043.jpg'
  ],
  'ChapurSubstation': [
    'no 036.jpg',
    'no 037.jpg',
    'no 042.jpg'
  ],
  'KhaniyakharkaRatanchuraRoad': [
    'khankharka1.jpg',
    'khanyakharka2.jpg',
    'khanyakharkha3.jpg'
  ],
  'KhurkotBaleniRafting': [
    'rafting.jpg',
    'rafting1.jpg',
    'rafting3.jpeg',
    'rafting4.jpg'
  ]
};

// Try common image patterns if not in mapping
const tryCommonImagePatterns = (photoDirectory) => {
  if (!photoDirectory) return null;
  
  const baseUrl = process.env.PUBLIC_URL || '';
  const commonPatterns = [
    'image1.jpg', 'image1.png', 'img1.jpg', 'img1.png',
    'photo1.jpg', 'photo1.png', '1.jpg', '1.png',
    '01.jpg', '01.png', '001.jpg', '001.png'
  ];
  
  // Return first pattern to try (browser will handle 404)
  return `${baseUrl}/Project Image/${photoDirectory}/${commonPatterns[0]}`;
};

// Get the first image for a project (for card display)
export const getProjectCardImage = (photoDirectory) => {
  if (!photoDirectory) return null;
  
  // If in mapping and has images, use that
  if (projectImageMap[photoDirectory] && projectImageMap[photoDirectory].length > 0) {
    const images = projectImageMap[photoDirectory];
    const baseUrl = process.env.PUBLIC_URL || '';
    return `${baseUrl}/Project Image/${photoDirectory}/${images[0]}`;
  }
  
  // Otherwise, try common patterns (will show placeholder if fails)
  return tryCommonImagePatterns(photoDirectory);
};

// Get all images for a project
export const getAllProjectImages = (photoDirectory) => {
  if (!photoDirectory || !projectImageMap[photoDirectory]) return [];
  
  const images = projectImageMap[photoDirectory];
  const baseUrl = process.env.PUBLIC_URL || '';
  
  return images.map(image => `${baseUrl}/Project Image/${photoDirectory}/${image}`);
};

